import { render, staticRenderFns } from "./SavedSearches.vue?vue&type=template&id=c11cb870&"
import script from "./SavedSearches.vue?vue&type=script&lang=js&"
export * from "./SavedSearches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports